<template lang="pug">
v-container.ma-0(grid-list-md)
  v-row
    v-col
      v-btn.mr-4(@click="addRule", tile, dark)
        |Add Rules
        v-icon mdi-plus
  v-layout(v-for="(rule, index) in value", :key="index", row)
    v-col
      v-text-field(
        label="Expression",
        v-model="value[index].expression"
      )
    v-col
      v-text-field(
        label="Error Message",
        v-model="value[index].errorMessage"
      )
    v-col
      v-btn(@click="deleteRule(index)", fab, dark, small)
        v-icon mdi-close
</template>

<script>
export default {
  name: 'RuleController',
  props: {
    value: {
      type: Array,
      default: () => ([]),
    },
  },
  data: () => ({}),
  methods: {
    addRule() {
      this.$emit('input', [...this.value, {}]);
    },
    deleteRule(val) {
      let temp = [ ...this.value ];
      temp.splice(val, 1);
      this.$emit('input', temp);
    },
  },
}
</script>
